import React from 'react';
import { connect } from 'react-redux';
import { AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Text, Accordion, } from '@spothero/ui';
import dayjs from 'utils/dayjs-duration';
import useConfig from 'hooks/use-config';
export const FAQPanels = ({ cancellationAllowed, canCancelHPEReservation = false, eventCancellationMinutes = 0, isMonthly, phoneNumber, phoneNumberFriendly, monthlyPhoneNumber, monthlyPhoneNumberFriendly, hours, }) => {
    const { siteUrl } = useConfig();
    const phoneText = isMonthly
        ? monthlyPhoneNumberFriendly
        : phoneNumberFriendly;
    const phoneHref = isMonthly ? monthlyPhoneNumber : phoneNumber;
    const getCancellationText = () => {
        // is this a high profile event and can the user cancel?
        if (eventCancellationMinutes > 0 && canCancelHPEReservation) {
            return `This reservation can be cancelled up to ${dayjs
                .duration(eventCancellationMinutes, 'minutes')
                .asHours()} hours before the reservation start time `;
        }
        else {
            return 'At this facility, you have up until the minute your reservation begins to cancel your parking ';
        }
    };
    const cancellationText = getCancellationText();
    const canCancel = cancellationAllowed !== 'no' && eventCancellationMinutes > 0
        ? canCancelHPEReservation
        : cancellationAllowed !== 'no';
    const textStyles = {
        fontFamily: 'body',
        flex: '1',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: 'base',
    };
    return (<Accordion allowMultiple allowToggle>
            {canCancel && (<AccordionItem className="FAQPanels-item" mx={2}>
                    <AccordionButton>
                        <AccordionIcon />
                        <Text {...textStyles}>Free Cancellation Policy</Text>
                    </AccordionButton>
                    <AccordionPanel data-testid="panel">
                        <Text fontSize="sm">
                            {cancellationText}
                            for a full refund. You can cancel your reservation
                            on the SpotHero website or app.
                        </Text>
                        <Text fontSize="sm">
                            If you&apos;re having trouble with your reservation
                            and it&apos;s after the start time, please reach out
                            to our Customer Heroes who are more than happy to
                            help rectify any situation!
                        </Text>
                    </AccordionPanel>
                </AccordionItem>)}
            <AccordionItem mx={2}>
                <AccordionButton>
                    <AccordionIcon />
                    <Text {...textStyles}>365-Day Customer Support</Text>
                </AccordionButton>
                <AccordionPanel data-testid="panel">
                    SpotHero has your back. If you have any issues while
                    parking, please call our Customer Heroes immediately at{' '}
                    <a className="support-phone" href={`tel:${phoneHref}`}>
                        {phoneText}
                    </a>
                    . We&apos;re here 365 days a year,{' '}
                    <span className="support-hours">{hours}</span>.
                    <br />
                    For non-urgent issues shoot us an email at{' '}
                    <a href="mailto:support@spothero.com">
                        support@spothero.com
                    </a>
                    . We&apos;ll get back you within 24 hours.
                </AccordionPanel>
            </AccordionItem>
            <AccordionItem mx={2}>
                <AccordionButton>
                    <AccordionIcon />
                    <Text {...textStyles}>Guaranteed Parking by SpotHero</Text>
                </AccordionButton>
                <AccordionPanel data-testid="panel">
                    <Text fontSize="sm">
                        When you park and pay with SpotHero, we guarantee you
                        will have a spot to park in at the price you paid or
                        your money back.
                    </Text>
                    <Text fontSize="sm">
                        If you need help with your reservation, please contact
                        us, and we&apos;ll do our best to make it right. Our
                        world-class Customer Hero team is available 7 days a
                        week, 365 days a year.
                    </Text>
                    <Text fontSize="sm">
                        For specifics, please refer to the{' '}
                        <a href={`${siteUrl}/about/parking-guarantee`}>
                            SpotHero Parking Guarantee
                        </a>
                    </Text>
                </AccordionPanel>
            </AccordionItem>
        </Accordion>);
};
const mapStateToProps = state => {
    const { searchRequest: { monthly: isMonthly }, city: { data: { phone_number: phoneNumber, phone_number_friendly: phoneNumberFriendly, monthly_phone_number: monthlyPhoneNumber, monthly_phone_number_friendly: monthlyPhoneNumberFriendly, weekday_hours: hours, }, }, } = state;
    return {
        isMonthly,
        phoneNumber,
        phoneNumberFriendly,
        monthlyPhoneNumber,
        monthlyPhoneNumberFriendly,
        hours,
    };
};
export default connect(mapStateToProps)(FAQPanels);
